import React from "react";
import { useI18n } from "../i18n/I18nContext";

function Section({ title, body, testid }) {
  return (
    <section className="mb-10" data-testid={testid}>
      <h2 className="font-heading text-2xl md:text-3xl text-[#0F172A] mb-4">
        {title}
      </h2>
      <p className="text-slate-700 leading-relaxed">{body}</p>
    </section>
  );
}

export default function LegalPage({ ns, testid }) {
  const { t } = useI18n();
  const sections = ["s1", "s2", "s3", "s4", "s5", "s6", "s7", "s8"].filter(
    (s) => t(`${ns}.${s}_title`) !== `${ns}.${s}_title`,
  );

  return (
    <main className="bg-white" data-testid={testid}>
      <div className="max-w-4xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#B48E5D] mb-4">
          Metrosenda
        </p>
        <h1 className="font-heading text-4xl md:text-5xl leading-tight text-[#0F172A]">
          {t(`${ns}.title`)}
        </h1>
        <p className="mt-4 text-sm text-slate-500">{t(`${ns}.updated`)}</p>

        <div className="mt-12">
          {sections.map((s) => (
            <Section
              key={s}
              testid={`${testid}-${s}`}
              title={t(`${ns}.${s}_title`)}
              body={t(`${ns}.${s}_body`)}
            />
          ))}
        </div>
      </div>
    </main>
  );
}
